export const EDIT_LOCK_CHANNEL_NAME = 'gx_dashboard_edit';

export type EditLockMessage =
  | { type: 'CLAIMED'; tabId: string }
  | { type: 'RELEASED'; tabId: string }
  | { type: 'FORCE_RELEASE' }
  | { type: 'QUERY_LOCK_STATE' }
  | { type: 'LOCK_STATE_RESPONSE'; holderTabId: string };
